import axios from "axios"

const getDefaultState = () => {
  return {
    posts: null,
    pagination: null,
    filterPostKey: null,
    isSearchingPosts: false,
    activityPostsLoading: false,
    msg: null,
    percent: null,
  }
}

const state = getDefaultState()

const getters = {
  percent: state => state.percent,
  msg: state => state.msg,
  posts: state => state.posts,
  pagination: state => state.pagination,
  isSearchingPosts: state => state.isSearchingPosts,
  activityPostsLoading: state => state.activityPostsLoading,
}

const mutations = {
  setPercent: (state, data) => {
    console.log("setPercent is called")
    state.percent = data
  },

  setMsg: (state, data) => {
    state.msg = data
  },

  startActivityPostsLoading: () => {
    state.activityPostsLoading = true
  },

  stopActivityPostsLoading: () => {
    state.activityPostsLoading = false
  },

  startPostsSearching: () => {
    state.isSearchingPosts = true
  },

  stopPostsSearching: () => {
    state.isSearchingPosts = false
  },

  setPosts: (state, { data }) => {
    state.posts = data.data
    state.pagination = data.paginator
  },

  resetPosts: (state, data) => {
    state.posts = null
    state.pagination = null
  },

  updatePosts: (state, { data }) => {
    state.posts = data.data
    state.pagination = data.paginator
  },

  // new search results
  updateSearchResults: (state, { data }) => {
    // state.posts = data.data;
    state.results = data.data
    state.pagination = data.paginator
  },

  viewMorePosts: (state, { data }) => {
    let newPosts = [...state.posts, data.data]
    let oldPost = [...state.posts]

    state.posts = [...oldPost, ...data.data]

    state.pagination = data.paginator
  },

  editPostReactions: (state, data) => {
    state.posts.filter(post => {
      if (post.id === data.response.reacted_on_id) {
        post.reaction[data.MIRROR_REACTION_TYPES[data.reactionType]] += 1
        const index = post.my_reaction.findIndex(rs => rs.reaction_type === data.reactionType)
        if (index >= 0) {
          post.my_reaction.splice(index, 1)
        }
        post.my_reaction.push(data.response)
      }
      return post
    })
  },

  deletePostReactions: (state, data) => {
    state.posts.filter(post => {
      if (post.id === data.reactions[0].reacted_on_id) {
        if (post.reaction[data.type] > 0) {
          post.reaction[data.type] -= 1
        }
      }
      return post
    })
  },

  setFilterSearchKey: (state, data) => {
    state.filterPostKey = data
  },

  addCommentCount: (state, data) => {
    state.posts.filter(post => {
      if (post.id === data) {
        return (post.comments_count += 1)
      }
    })
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/posts.js